// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/mbg3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles */
.footer-section {
  background:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 80px;
  position: relative;
  overflow: hidden;
  border-radius: 30px;
}

.footer-container {
  margin: 0 auto;
  padding: 80px;
  align-items: flex-end !important;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 2;
}

/* Left Section */
.footer-left {
  flex: 1 1;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.footer-logo {
  margin-bottom: 20px;
}

.footer-logo-img {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-newsletter {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-heading {
  color: white;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.footer-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 400px;
}

.footer-email-input {
  background: white;
  border: none;
  border-radius: 50px;
  padding: 16px 24px;
  font-size: 16px;
  color: #333;
  outline: none;
  transition: all 0.3s ease;
}

.footer-email-input::placeholder {
  color: #999;
}

.footer-email-input:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

.footer-subscribe-btn {
  background: #303B64;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  max-width: 200px;
}

.footer-subscribe-btn:hover {
  background: #404B74;
  transform: translateY(-2px);
}

.footer-social {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.social-link {
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  color: white;
}

/* Right Section */
.footer-right {
  flex: 1 1;
  max-width: 50%;
  position: absoulte;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 300px;
}

.footer-bg-logo {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  opacity: 0.3;
  z-index: 1;
}

.footer-bg-logo-img {
  height: 200px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-copyright {
  color: white;
  font-size: 14px;
  opacity: 0.8;
  text-align: right;
  margin-top: auto;
  z-index: 2;
  position: relative;
  padding-bottom: 0px !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-section {
    padding: 60px 0 30px;
    border-radius: 30px 30px 0 0;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 10px;
  }
  
  .footer-left,
  .footer-right {
    max-width: 100%;
  }
  
  .footer-heading {
    font-size: 28px;
  }
  
  .footer-form {
    max-width: 100%;
  }
  
  .footer-subscribe-btn {
    max-width: 100%;
  }
  
  .footer-right {
    height: 200px;
  }
  
  .footer-bg-logo-img {
    height: 150px;
  }
  
  .footer-copyright {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-section {
    padding: 40px 0 20px;
    border-radius: 20px 20px 0 0;
  }
  
  .footer-heading {
    font-size: 24px;
  }
  
  .footer-email-input,
  .footer-subscribe-btn {
    padding: 14px 20px;
    font-size: 14px;
  }
  
  .footer-social {
    gap: 15px;
  }
  
  .social-link {
    width: 35px;
    height: 35px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,oDAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Footer Styles */\n.footer-section {\n  background:  url('/public/mbg3.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-top: 80px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 30px;\n}\n\n.footer-container {\n  margin: 0 auto;\n  padding: 80px;\n  align-items: flex-end !important;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: relative;\n  z-index: 2;\n}\n\n/* Left Section */\n.footer-left {\n  flex: 1;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n.footer-logo {\n  margin-bottom: 20px;\n}\n\n.footer-logo-img {\n  height: 40px;\n  width: auto;\n  filter: brightness(0) invert(1);\n}\n\n.footer-newsletter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.footer-heading {\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.footer-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  max-width: 400px;\n}\n\n.footer-email-input {\n  background: white;\n  border: none;\n  border-radius: 50px;\n  padding: 16px 24px;\n  font-size: 16px;\n  color: #333;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.footer-email-input::placeholder {\n  color: #999;\n}\n\n.footer-email-input:focus {\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n}\n\n.footer-subscribe-btn {\n  background: #303B64;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 16px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  max-width: 200px;\n}\n\n.footer-subscribe-btn:hover {\n  background: #404B74;\n  transform: translateY(-2px);\n}\n\n.footer-social {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.social-link {\n  color: white;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.social-link:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  color: white;\n}\n\n/* Right Section */\n.footer-right {\n  flex: 1;\n  max-width: 50%;\n  position: absoulte;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  height: 300px;\n}\n\n.footer-bg-logo {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  opacity: 0.3;\n  z-index: 1;\n}\n\n.footer-bg-logo-img {\n  height: 200px;\n  width: auto;\n  filter: brightness(0) invert(1);\n}\n\n.footer-copyright {\n  color: white;\n  font-size: 14px;\n  opacity: 0.8;\n  text-align: right;\n  margin-top: auto;\n  z-index: 2;\n  position: relative;\n  padding-bottom: 0px !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .footer-section {\n    padding: 60px 0 30px;\n    border-radius: 30px 30px 0 0;\n  }\n  \n  .footer-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .footer-left,\n  .footer-right {\n    max-width: 100%;\n  }\n  \n  .footer-heading {\n    font-size: 28px;\n  }\n  \n  .footer-form {\n    max-width: 100%;\n  }\n  \n  .footer-subscribe-btn {\n    max-width: 100%;\n  }\n  \n  .footer-right {\n    height: 200px;\n  }\n  \n  .footer-bg-logo-img {\n    height: 150px;\n  }\n  \n  .footer-copyright {\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-section {\n    padding: 40px 0 20px;\n    border-radius: 20px 20px 0 0;\n  }\n  \n  .footer-heading {\n    font-size: 24px;\n  }\n  \n  .footer-email-input,\n  .footer-subscribe-btn {\n    padding: 14px 20px;\n    font-size: 14px;\n  }\n  \n  .footer-social {\n    gap: 15px;\n  }\n  \n  .social-link {\n    width: 35px;\n    height: 35px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
